module.exports = __webpack_public_path__ + "static/media/bg-07.2697176e.png";